import { Currency } from './Currency';
import { Place } from './Place';
import { Unit } from './Unit';

export interface RouteSegment {
    id?: number;

    origin_id?: number;
    origin?: Place;
    destiny_id?: number;
    destiny?: Place;
    distance?: number | string;
    rate?: number | string;
    currency_id?: number;
    currency?: Currency;
    unit_id?: number;
    unit?: Unit;
    name?: string;
    createdAt?: Date | string;
    updatedAt?: Date | string;

    rate_runner?: number | string;
    currency_rate_runner?: Currency;
    currency_rate_runner_id?: number | string;
    quantity_unit_rate_runner?: Unit;
    quantity_unit_rate_runner_id?: number | string;
    rate_transporter?: number | string;
    currency_rate_transporter?: Currency;
    currency_rate_transporter_id?: number | string;
    quantity_unit_rate_transporter?: Unit;
    quantity_unit_rate_transporter_id?: number | string;
}

export interface RouteSegmentFilters {
    route_segment_id?: number | null;
    start_date?: string | null;
    end_date?: string | null;
    origin?: string | null;
    destiny?: string | null;
    page: number;
    per_page: number;
    sort: string;
    order: string;
}

export interface RouteSegmentDataForm {
    id?: number;
    origin_id?: number | string;
    origin?: Place;
    destiny_id?: number | string;
    destiny?: Place;
    distance?: number | string;
    rate?: number | string;
    currency_id?: number | string;
    currency?: Currency;

    unit_id?: number | string;
    unit?: Unit;
    created_at?: string;
    created_user?: string;
    updated_at?: string;
    last_modified_user?: string;

    rate_runner?: number | string;
    currency_rate_runner_id?: number | string;
    quantity_unit_rate_runner_id?: number | string;
    rate_transporter?: number | string;
    currency_rate_transporter_id?: number | string;
    quantity_unit_rate_transporter_id?: number | string;
}

export interface Routes {
    id?: number;
    name?: string;
    agreed_distance?: number;

    rate_runner?: number;
    currency_rate_runner_id?: number;
    quantity_unit_rate_runner_id?: number;
    rate_transporter?: number;
    currency_rate_transporter_id?: number;
    quantity_unit_rate_transporter_id?: number;

    rate?: number;

    currency_id?: number;

    unit_id?: number;
}

export interface RouteSegmentShowDataForm {
    id?: number;
    origin?: Place;
    destiny?: Place;
    distance?: number | string;
    currency?: Currency;
    unit?: Unit;
    created_at?: string;
    created_user?: string;
    updated_at?: string;
    last_modified_user?: string;
}

export const defaultRouteSegmentDataForm: RouteSegmentDataForm = {
    origin_id: 0,
    destiny_id: 0,
    distance: 0,
    rate: 0,
    unit_id: undefined,
    currency_id: undefined,

    rate_runner: 0,
    currency_rate_runner_id: undefined,
    quantity_unit_rate_runner_id: undefined,
    rate_transporter: 0,
    currency_rate_transporter_id: undefined,
    quantity_unit_rate_transporter_id: undefined
};
